export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7756.412de590.jpg";